module.exports = __webpack_public_path__ + "img/tools-included-in-plan.bb0cdd54.png";